import {
  RetrieveSeasonFights,
  RetrieveSeasonFightsFailure,
  RetrieveSeasonFightsPayload,
  RetrieveSeasonFightsSuccess,
  RetrieveSeasonFightsSuccessPayload,
  RETRIEVE_SEASON_FIGHTS,
  RETRIEVE_SEASON_FIGHTS_FAILURE,
  RETRIEVE_SEASON_FIGHTS_SUCCESS,
} from './seasonFights.action.type';

export const retrieveSeasonFights = (
  payload: RetrieveSeasonFightsPayload,
): RetrieveSeasonFights => ({
  type: RETRIEVE_SEASON_FIGHTS,
  payload,
});

export const retrieveSeasonFightsSuccess = (
  payload: RetrieveSeasonFightsSuccessPayload,
): RetrieveSeasonFightsSuccess => ({
  type: RETRIEVE_SEASON_FIGHTS_SUCCESS,
  payload,
});

export const retrieveSeasonFightsFailure = (
  error: string,
): RetrieveSeasonFightsFailure => ({
  type: RETRIEVE_SEASON_FIGHTS_FAILURE,
  payload: error,
});
